<template>
  <div
    class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    :class="`card-${cardType}`"
  >
    <span class="mr-10px card-title-label"> {{ title }}</span>
    <slot name="extend"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题',
    },
    cardType: {
      // default | horizontal
      type: String,
      default: 'default',
    },
  },
}
</script>

<style scoped lang="scss">

.card-title {
  background-size: 100% 100%;
  &.card-default {
    background-image: var(--diyCardTitleBg);
  }
  &.card-dongjiang {
    background-image: var(--diyCardTitleBgDj);
    background-position: 0px 0.5rem;
    margin-bottom: 0;
  }
  &.card-dongjiangLong {
    background-image: var(--diyCardTitleBgDjLong);
    background-position: 0px 0.5rem;
    margin-bottom: 0;
  }
  &.card-horizontal {
    background-image: var(--diyCardTitleBgHor, --diyCardTitleBg);
  }
  &.card-shimen {
    margin: 0px !important;
    display: flex;
    background-image: var(--diyCardTitleBg);
    justify-content: space-between;
  }
  .card-title-label {
    font-family: var(--diyCardTitleFont, 'none');
  }
}

</style>
